import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { useDispatch, useSelector } from 'react-redux';

import { streamPermissionsActions } from 'store/streamPermissionsSlice/streamPermissionsSlice';
import {
    selectStreamPermissionsDialogOpen,
    selectMicPermissionMissing,
    selectLocalNetworkPermissionMissing,
} from 'store/streamPermissionsSlice/streamPermissionsSelectors';

import styles from './StreamPermissionsDialog.module.css';

const DIALOG_TITLE = 'Permissions required';
const paperSx = { '& .MuiPaper-root': { borderRadius: 1, width: 520, margin: 0, maxWidth: 'calc(100% - 16px)' } };

function StreamPermissionsDialog() {
    const dispatch = useDispatch();
    const open = useSelector(selectStreamPermissionsDialogOpen);
    const micMissing = useSelector(selectMicPermissionMissing);
    const localNetworkMissing = useSelector(selectLocalNetworkPermissionMissing);

    const handleClose = () => dispatch(streamPermissionsActions.closeDialog());

    return (
        <Dialog open={open} onClose={handleClose} aria-label={DIALOG_TITLE} sx={paperSx}>
            <DialogTitle className={styles['dialog-title']}>
                <span className={styles.heading}>
                    <WarningAmberRoundedIcon color="warning" className={styles.icon} />
                    {DIALOG_TITLE}
                </span>
                <IconButton aria-label="close" onClick={handleClose} className={styles['close-button']}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent className={styles['dialog-content']}>
                <p className={styles.intro}>To connect to the video servers, AIQ needs the following permission(s) in Chrome:</p>
                <ul className={styles.list}>
                    {micMissing ? (
                        <li>
                            <strong>Microphone</strong>
                        </li>
                    ) : null}
                    {localNetworkMissing ? (
                        <li>
                            <strong>Local network</strong>
                        </li>
                    ) : null}
                </ul>
                <p className={styles.outro}>
                    Open AIQ&apos;s permissions (the icon at the left of the address bar) and allow it. Then reload the page.
                </p>
            </DialogContent>
            <DialogActions className={styles['dialog-actions']}>
                <Button variant="contained" onClick={handleClose} autoFocus>
                    Got it
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default StreamPermissionsDialog;
